import { zoneShape, type Shape } from './shapes';
import type { ProjectResults } from '../engine/assess';
import type { GasGroup, ProjectDoc, ZoneNumber } from '../model/types';

/** One zone volume placed in the scene. */
export interface ZoneInstance {
  id: string;
  sourceId: string;
  areaId: string;
  zone: ZoneNumber;
  role: 'single' | 'inner' | 'outer';
  gasGroup?: GasGroup;
  aitC?: number;
  shape: Shape;
}

export function zoneInstances(doc: ProjectDoc, results: ProjectResults): ZoneInstance[] {
  const substances = new Map(doc.substances.map((s) => [s.id, s]));
  const areas = new Map(doc.areas.map((a) => [a.id, a]));
  const out: ZoneInstance[] = [];
  for (const source of doc.sources) {
    const r = results.sources[source.id];
    if (!r) continue;
    const sub = substances.get(source.substanceId);
    const area = areas.get(source.areaId);
    r.volumes.forEach((volume, i) => {
      const shape = zoneShape({
        volume,
        sourcePosition: source.position,
        release: source.release,
        releaseForm: source.releaseForm,
        ...(source.shape ? { override: source.shape } : {}),
        ...(area?.box ? { roomBox: area.box } : {}),
      });
      if (!shape) return;
      out.push({
        id: `${source.id}:${i}`,
        sourceId: source.id,
        areaId: source.areaId,
        zone: volume.zone,
        role: volume.role,
        ...(sub?.gasGroup ? { gasGroup: sub.gasGroup } : {}),
        ...(sub?.aitC !== undefined ? { aitC: sub.aitC } : {}),
        shape,
      });
    });
  }
  return out;
}
